import { cn } from "@/lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("rounded-md animate-pulse bg-athens-gray-100", className)}
      {...props}
    />
  );
}

export { Skeleton };








